import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ThirdpartywebpopupPage } from './thirdpartywebpopup';

@NgModule({
  declarations: [
    ThirdpartywebpopupPage,
  ],
  imports: [
    IonicPageModule.forChild(ThirdpartywebpopupPage),
  ],
})
export class ThirdpartywebpopupPageModule {}



// WEBPACK FOOTER //
// ./src/app/shared/thirdpartywebpopup/thirdpartywebpopup.module.ts